import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, UntypedFormGroup, Validators} from "@angular/forms";
import {arrayIsSet, GlobalVariablesService, stringIsSet} from "../../../providers/service/global-variables.service";
import {ProgettiParse} from "../../../ParseClass/Progetti.Parse";
import {dataForm} from "../../../widget/auto-complete-form/auto-complete-form.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-invite-user',
    templateUrl: './invite-user.component.html',
    styleUrls: ['./invite-user.component.scss'],
    standalone: false
})
export class InviteUserComponent implements OnInit {
    public form: FormGroup

    constructor(
        public dialogRef: MatDialogRef<InviteUserComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            formDefualtValue: {
                houseId: string,
                email: string,
                phone: string
            },
            projectPossibleValues: ProgettiParse[] | undefined
        },
        private fb: FormBuilder,) {
        this.form = this.fb.group({
            houseId: [undefined, [Validators.required]],
            email: [undefined, [Validators.required, Validators.email]],
            phone: [undefined, [Validators.required]]
        })
        if (this.data != null) {
            if (this.data.formDefualtValue != null) {
                Object.keys(this.data.formDefualtValue)
                    .forEach((k) => {
                        if (this.form.get(k) != null) {
                            this.form.get(k)?.setValue((this.data.formDefualtValue as any)[k]);
                        }
                    })
            }
        }
    }

    ngOnInit(): void {
    }

    confirmValue() {
        this.dialogRef.close(this.form.value);
    }

    predicatePossibleValue(projects: ProgettiParse[]): dataForm[] {
        if (!arrayIsSet(projects)) {
            return [];
        }
        return projects.map(p => {
            let traduction = ''
            if (stringIsSet(p.name)) {
                traduction += p.name;
            }
            if (stringIsSet(p.referenceName)) {
                traduction += ' - ' + p.referenceName;
            }
            const data: dataForm = {
                valueForm: p.objectId!,
                html: p.objectId!,
                traduction:stringIsSet(traduction)?traduction:undefined
            };
            return data;
        })
    }
}
